import React from 'react';

export default function PreviewToolbar({
  hasDesignContent,
  isDesignVersion,
  onShowDesign
}) {

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '12px',
      marginBottom: '16px'
    }}>
      {hasDesignContent && isDesignVersion && (
        <button
          onClick={() => onShowDesign()}
          style={{
            padding: '8px 16px',
            backgroundColor: '#4f46e5',
            color: 'white',
            borderRadius: '8px',
            fontWeight: '500',
            fontSize: '14px',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            flexShrink: 0
          }}
        >
          <span style={{ display: 'inline-flex' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 2a.5.5 0 0 1 .5.5V4h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0V5h-2a.5.5 0 0 1 0-1h2V2.5A.5.5 0 0 1 8 2zm4.5 3A2.5 2.5 0 0 0 10 2.5H6a2.5 2.5 0 0 0-2.5 2.5v5A2.5 2.5 0 0 0 6 12.5h4a2.5 2.5 0 0 0 2.5-2.5v-5z"/>
            </svg>
          </span>
          Go to Design
        </button>
      )}
    </div>
  );
}
